<template>
  <div :class="['animate-pulse bg-gray-200', className] | twMerge" />
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    className: [String, Array]
  }
}
</script>
